import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'bytes',
    standalone: true,
})
export class BytesPipe implements PipeTransform {
    transform(bytes: number, decimals = 2): string {
        if (!Number(bytes)) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = Math.max(0, decimals);
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
}
